// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminCampaignController from "./admin_campaign_controller"
application.register("admin-campaign", AdminCampaignController)

import AiChatController from "./ai_chat_controller"
application.register("ai-chat", AiChatController)

import CampaignController from "./campaign_controller"
application.register("campaign", CampaignController)

import PostEditWarningController from "./post_edit_warning_controller"
application.register("post-edit-warning", PostEditWarningController)

import ChartjsController from "./chartjs_controller"
application.register("chartjs", ChartjsController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DepositController from "./deposit_controller"
application.register("deposit", DepositController)

import LoadingSpinnerController from "./loading_spinner_controller"
application.register("loading-spinner", LoadingSpinnerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import ModalSubmitController from "./modal_submit_controller"
application.register("modal-submit", ModalSubmitController)

import NavigatorController from "./navigator_controller"
application.register("navigator", NavigatorController)

import OffcanvasController from "./offcanvas_controller"
application.register("offcanvas", OffcanvasController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import TransferAdjustmentController from "./transfer_adjustment_controller"
application.register("transfer-adjustment", TransferAdjustmentController)

import TransferStatusConfirmationController from "./transfer_status_confirmation_controller"
application.register("transfer-status-confirmation", TransferStatusConfirmationController)
